import PropTypes from 'prop-types';
import React, { memo } from 'react';

import { HolidayIcon } from '@/assets';

import { StyledTag } from './PublicHolidayTag.styles';

const PublicHolidayTag = ({ label, ...props }) => (
  <StyledTag label={label} icon={<HolidayIcon />} {...props} />
);

PublicHolidayTag.propTypes = {
  label: PropTypes.string.isRequired,
};

export default memo(PublicHolidayTag);
